function _(c,e,n){const s=c(64);class o extends s.Model{constructor(c){super(c)}}n.Ticker=o,o.__name__="Ticker"}
//# sourceMappingURL=ticker.min.js.map